import React, { Component } from 'react';
import { Form, Spin } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LinkInput } from 'components';
import { ProjectsActions } from 'redux/actions';
import {
  PrimaryButton,
  formLayout,
  FormWrapper,
} from 'utils';

const FormItem = Form.Item;

class InputUrlModal extends Component {
  formRef = React.createRef();

  static propTypes = {
    checkUrl: PropTypes.func.isRequired,
    projectId: PropTypes.string.isRequired,
    handleDuplicateProject: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };

  state = {
    link: 'test',
    creating: false,
  };

  onFinish = (values) => {
    const url = `${values.url}`.toLowerCase();

    const {
      handleDuplicateProject
    } = this.props;

    handleDuplicateProject(url);
  };

  render() {
    const { projectId, loading } = this.props;
    return (
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          ref={this.formRef}
          name="input-url"
          onFinish={this.onFinish}
        >
          <div>
            <FormWrapper>
              <>
                <p>
                  Bevor du das Projekt duplizieren kannst, musst du eine neue URL für das duplizierte Projekt eingeben.
                </p>

                <LinkInput projectId={projectId} />
              </>
            </FormWrapper>
          </div>

          <FormItem>
            <PrimaryButton
              type="primary"
              htmltype="submit"
              minWidth="150px"
              style={{ marginBottom: 0 }}
            >
              Senden
            </PrimaryButton>
          </FormItem>
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const { loading } = state.projects;
  return {
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  checkUrl: (url) => dispatch(ProjectsActions.checkUrl(url)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InputUrlModal);
